var Formatting = (function() {
	var __private = {
		VALUE: "",
		location: "en-US",
		currency: "$ ",

		format(num) {
			this.VALUE = this.currency + new Intl.NumberFormat(this.location).format(num);
		}
	};

	return {
		currency(N) {
			__private.format(N);
			return __private.VALUE;
		}
	};
})();